import React, { useState } from "react";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import GdanskSaleStep2Form from "./GdanskSaleStep2Form";
import GdanskSaleContentContainer from "../GdanskSaleContentContainer";
import { GDANSK_KIND_BASIC_PASS, GDANSK_PASS, GDANSK_TICKET, getTitleByProductKind } from "./gdanskSaleStepsConsts";

interface IProps {
  form: GdanskSaleForm;
  setForm: (form: GdanskSaleForm) => void;
  onGoBack: () => void;
  onNextStep: () => void;
}

const GdanskSaleStep2: React.FC<IProps> = ({ form, setForm, onGoBack, onNextStep }) => {
  const [isFormValid, setIsFormValid] = useState(false);

  const getTitleByProductType = () => {
    if (form.productMainType === GDANSK_TICKET) {
      return "Dostosuj swój bilet";
    } else if (form.productMainType === GDANSK_PASS) {
      return "Dostosuj swój karnet";
    } else {
      return "Nieprawidłowy typ produktu";
    }
  };

  const getDescriptionByProductType = () => {
    switch (form.kind) {
      case GDANSK_KIND_BASIC_PASS:
        return "Karnet Tradycyjny umożliwia rezerwacje konkretnego toru w kontrenym dniu i godzinie.";
      default:
        return "";
    }
  };

  return (
    <GdanskSaleContentContainer
      title={getTitleByProductType()}
      description={getDescriptionByProductType()}
      showButtons
      disabledAccept={!isFormValid}
      showGoBackButton
      onClickGoBack={onGoBack}
      onClickNext={onNextStep}
      previousStepInfo={getTitleByProductKind(form.kind)}
    >
      <GdanskSaleStep2Form form={form} setForm={setForm} setIsFormValid={setIsFormValid} />
    </GdanskSaleContentContainer>
  );
};

export default GdanskSaleStep2;
